import { MUITab } from "@abb/arcadia-ui-react"
import { useContext } from "react"
import { DiMaProgress } from "../../components/DiMaProgress"
import { UserContext } from "../../context/UserContext"
import { useHashTab } from "../../../hooks/useHashTab"
import { GatewaysManufacturedDevices } from "./supplier_tab/GatewaysManufacturedDevices"

const DEFAULT_TAB = "manufactured-devices"

export function GatewaysContainer() {
  const { user } = useContext(UserContext)
  const { activeTab, handleTabChange } = useHashTab(DEFAULT_TAB)

  if (!user) {
    return <DiMaProgress />
  }

  return (
    <div>
      <MUITab
        tabItems={[{ id: DEFAULT_TAB, label: "Manufactured Devices" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === DEFAULT_TAB && <GatewaysManufacturedDevices />}
    </div>
  )
}
